// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4b525ddc","879":"c6c5ea3c"}[chunkId] + ".chunk.js";
};